import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard, Check, Gift } from 'lucide-react';
import { Button } from '../ui/Button';
import { CountdownTimer } from '../ui/CountdownTimer';
const CHECKOUT_URL = 'https://checkout.ebookpoint.shop/cart/59618889433169:1';
const freeBonuses = ['🥤 Calculadora de proteína e hidratación.', '🧠 Bono de psicología deportiva para afrontar tus entrenamientos.', '💊 Guía de suplementos con evidencia científica: cuáles comprar y cuáles no.'];
const summary = ['📚 6 Capítulos completos (Tomos 1 a 6)', '🎁 6 Bonos exclusivos', '🏅 Bono ELITE: Triatlón en 6HS'];
export function Pricing() {
  return <section id="comprar" className="py-20 bg-brand-dark relative overflow-hidden" data-id="element-70">
      {/* subtle accent glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-green/5 rounded-full blur-3xl pointer-events-none" data-id="element-71" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-72">
        <div className="text-center mb-10" data-id="element-73">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 bg-brand-green text-brand-dark text-xs font-bold tracking-wider uppercase rounded-full mb-6 shadow-[0_0_15px_rgba(204,255,0,0.3)]" data-id="element-74">
            ⚡ OFERTA POR TIEMPO LIMITADO
          </motion.span>

          {/* Countdown - dark variant */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="max-w-md mx-auto" data-id="element-75">
            <CountdownTimer variant="dark" data-id="element-76" />
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="bg-white rounded-3xl shadow-2xl shadow-brand-green/10 overflow-hidden border border-white/10" data-id="element-77">
          <div className="bg-brand-dark text-white text-center py-3 border-b border-white/10" data-id="element-78">
            <p className="text-xs md:text-sm font-bold tracking-widest uppercase flex items-center justify-center gap-2" data-id="element-79">
              <span className="text-brand-green animate-pulse" data-id="element-80">●</span> ACCESO
              INMEDIATO
            </p>
          </div>

          <div className="p-6 md:p-10" data-id="element-81">
            <h3 className="font-serif text-2xl md:text-3xl font-bold text-brand-dark mb-8 text-center" data-id="element-82">
              Dominá tu primer triatlón
            </h3>

            {/* Two-column layout for contents */}
            <div className="grid md:grid-cols-2 gap-4 mb-8" data-id="element-83">
              {/* Core System */}
              <div className="bg-slate-50 border border-slate-100 rounded-2xl p-5 md:p-6" data-id="element-84">
                <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-85">
                  <Check size={14} data-id="element-86" />
                  El sistema completo
                </p>
                <ul className="space-y-3" data-id="element-87">
                  {summary.map((f, i) => <li key={i} className="flex items-start gap-2.5 text-sm text-slate-700 leading-snug font-medium" data-id="element-88">
                      <Check size={16} className="text-slate-400 flex-shrink-0 mt-0.5" data-id="element-89" />
                      <span data-id="element-90">{f}</span>
                    </li>)}
                </ul>
              </div>

              {/* Free Bonuses */}
              <div className="bg-[#f4fce3] border border-brand-green/30 rounded-2xl p-5 md:p-6 relative overflow-hidden" data-id="element-91">
                <div className="absolute top-0 right-0 bg-brand-green text-brand-dark text-[10px] font-bold px-3 py-1 rounded-bl-xl tracking-wider" data-id="element-92">
                  GRATIS HOY
                </div>
                <p className="text-xs font-bold text-brand-green-dark uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-93">
                  <Gift size={14} data-id="element-94" />
                  Tus regalos
                </p>
                <ul className="space-y-3" data-id="element-95">
                  {freeBonuses.map((b, i) => <li key={i} className="flex items-start gap-2.5 text-sm text-brand-dark leading-snug font-medium" data-id="element-96">
                      <span className="flex-shrink-0 mt-0.5 flex items-center justify-center w-5 h-5 rounded-full bg-brand-green/30 text-brand-green-dark" data-id="element-97">
                        <Gift size={10} data-id="element-98" />
                      </span>
                      <span data-id="element-99">{b}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            {/* Price Block */}
            <div className="flex flex-col items-center justify-center mb-8 relative" data-id="element-100">
              <div className="absolute w-full h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent top-1/2 -translate-y-1/2 -z-10" data-id="element-101" />
              <div className="bg-white px-6 text-center" data-id="element-102">
                <span className="text-slate-400 line-through text-lg md:text-xl font-medium block mb-1" data-id="element-103">
                  $49.990
                </span>
                <div className="flex items-baseline justify-center gap-2" data-id="element-104">
                  <span className="font-serif text-5xl md:text-7xl font-bold text-brand-dark tracking-tight" data-id="element-105">
                    $19.990
                  </span>
                  <span className="text-slate-500 text-sm md:text-base font-bold" data-id="element-106">
                    ARS
                  </span>
                </div>
              </div>
            </div>

            <Button href={CHECKOUT_URL} className="w-full px-6 py-5 text-base md:text-lg mb-6 shadow-xl shadow-brand-green/20 hover:shadow-brand-green/40 transition-all duration-300" data-id="element-107">
              → QUIERO DESBLOQUEAR MI PRIMER TRIATLÓN
            </Button>

            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center items-center gap-3 md:gap-6 text-xs md:text-sm text-slate-500 font-medium bg-slate-50 py-3 px-4 rounded-xl" data-id="element-108">
              <div className="flex items-center gap-1.5" data-id="element-109">
                <ShieldCheck size={16} className="text-brand-green-dark" data-id="element-110" />
                <span data-id="element-111">Garantía 7 días</span>
              </div>
              <span className="text-slate-300 hidden md:block" data-id="element-112">•</span>
              <div className="flex items-center gap-1.5" data-id="element-113">
                <Lock size={16} className="text-brand-green-dark" data-id="element-114" />
                <span data-id="element-115">Pago seguro</span>
              </div>
              <span className="text-slate-300 hidden md:block" data-id="element-116">•</span>
              <div className="flex items-center gap-1.5" data-id="element-117">
                <CreditCard size={16} className="text-brand-green-dark" data-id="element-118" />
                <span data-id="element-119">Mercado Pago</span>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="text-center text-white/40 text-xs mt-6 font-medium tracking-wide" data-id="element-120">
          Todo este contenido es respaldado con evidencia científica.
        </motion.p>
      </div>
    </section>;
}